// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Schedule State
// -------------------------------
export interface ScheduleState extends EntityState<any> {
  common?: any;
  shiftTemplates: [];
  meSchedule: any;
}

// -------------------------------
//  Schedule Adapter
// -------------------------------
export const ScheduleAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Schedule Initial State
// -------------------------------
export const initialState: ScheduleState = ScheduleAdapter.getInitialState(
  {
    common: null,
    shiftTemplates: [],
    meSchedule: {},
  },
);
